// ============================================================
// CART DRAWER - COMPLETE FIXED VERSION
// v25.1 - Le tiroir s ouvre UNE FOIS, avec le panier complet.
//
//         Historique : v23.0 avait retire Replo (plus aucun intercept
//         fetch/XHR, plus de polling, plus de spinner).
//
// LES QUATRE CORRECTIFS DE CETTE VERSION
// --------------------------------------
// 1. PONT AJOUT EXTERNE (le correctif principal, en bas du fichier).
//    Le bouton d'ajout de cette boutique est celui de GemPages
//    (gp-product-button-v7-5.js), enveloppe par Kaching Bundles. Il appelle
//    /cart/add.js directement, sans passer par product-form.js du theme.
//    renderContents() n'etait donc jamais appele, et open() non plus.
//    Le pont surveille les appels /cart/add, rafraichit le contenu du
//    tiroir, puis l'ouvre.
//
// 2. VERROU D'ARBITRAGE NEUTRALISE.
//    themeDrawerIsEngine() cherchait « #kaching-cart, .kaching-cart,
//    [data-kaching-cart] » dans le DOM. La simple PRESENCE d'un de ces
//    elements — meme vide, meme masque — faisait sortir open() sans rien
//    faire. Pilote desormais par une constante, reglee sur false.
//
// 3. REOUVERTURE APRES AJOUT RETABLIE.
//    renderContents() refusait d'ouvrir si close() datait de moins de
//    1500 ms. Or un ajout au panier est toujours une intention explicite de
//    voir le panier. Remplace par un drapeau a usage unique, pose uniquement
//    par clearCart() — la seule situation ou rouvrir serait absurde.
//
// 4. ICONE PANIER REBRANCHEE.
//    L'ouverture depuis l'icone avait ete deleguee a cart-router.liquid.
//    Si ce fichier manque, plus aucun moyen de rouvrir son panier. Le
//    branchement est retabli, avec une garde anti-doublon si le routeur
//    existe et branche deja l'icone.
// ============================================================

// Garde : cdLog est appele dans ce fichier sans y etre defini.
// S'il n'existe pas ailleurs, tout le script apres son premier appel mourait.
// Journalisation desactivee en production. Passer window.CART_DRAWER_DEBUG = true
// dans la console pour reactiver la trace.
window.cdLog = window.cdLog || function () {
  if (!window.CART_DRAWER_DEBUG) return;
  try { console.log.apply(console, arguments); } catch (e) {}
};

/* ------------------------------------------------------------------
   CORRECTIF 2 — Arbitrage avec un slide cart d'application.

   Repasser a true UNIQUEMENT si un panier lateral d'application est
   reinstalle et doit reprendre la main. Tant que c'est false, le tiroir
   du theme s'ouvre toujours, quels que soient les elements laisses dans
   le DOM par d'anciennes applications.

   A noter : Kaching BUNDLES et Kaching CART sont deux applications
   distinctes. Desactiver cet arbitrage ne touche pas aux bundles.
------------------------------------------------------------------ */
var CART_DRAWER_APP_ARBITRATION = false;

function themeDrawerIsEngine() {
  if (!CART_DRAWER_APP_ARBITRATION) return true;
  if (window.CartEngine && typeof window.CartEngine.themeDrawerActive === 'function') {
    return window.CartEngine.themeDrawerActive();
  }
  return !document.querySelector('#kaching-cart, .kaching-cart, [data-kaching-cart]');
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  _preventScroll(e) {
    const scrollable = e.target.closest('.cart-drawer-items-and-upsell');
    if (!scrollable) {
      e.preventDefault();
    }
  }

  /* CORRECTIF 4 — l'ouverture depuis l'icone panier est rebranchee ici.
     Elle avait ete deleguee a cart-router.liquid ; si ce fichier manque,
     le visiteur ne peut plus rouvrir son panier une fois le tiroir ferme.
     Si le routeur existe et branche lui aussi l'icone, les deux appels a
     open() ne se genent pas — le second voit le tiroir deja actif et rend
     la main — mais la garde ci-dessous evite le doublon. */
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    if (cartLink.dataset.hlyBound) return;
    cartLink.dataset.hlyBound = '1';

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      /* event.code est absent sur certains claviers virtuels : sans ce test,
         le .toUpperCase() leverait une exception. */
      if (event.code && event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  // Vrai si l'utilisateur a ferme volontairement il y a moins de windowMs.
  // Conserve pour compatibilite : n'est plus utilise pour bloquer une
  // ouverture consecutive a un ajout au panier (voir renderContents).
  userJustClosed(windowMs = 4000) {
    return !!this._closedAt && (Date.now() - this._closedAt) < windowMs;
  }

  open(triggeredBy) {
    // Verrou d'arbitrage. Neutralise : CART_DRAWER_APP_ARBITRATION vaut
    // false, donc themeDrawerIsEngine() rend toujours true.
    if (!themeDrawerIsEngine()) {
      cdLog('[CartDrawer] open() → refuse : un slide cart applicatif est actif');
      return;
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // Toute ouverture explicite annule l'etat "ferme par l'utilisateur"
    this._wantsOpen = true;

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    // Si le drawer est deja ouvert : pas d'animation ni de trapFocus,
    // on dispatch l'evenement et on relance le timer.
    if (this.classList.contains('active')) {
      cdLog('[CartDrawer] open() → already active, dispatching event immediately');
      document.dispatchEvent(new CustomEvent('cart-drawer:opened'));
      this.initTimer();
      return;
    }

    // L'ajout des classes est annulable par close()
    clearTimeout(this._openTimeout);
    this._openTimeout = setTimeout(() => {
      if (!this._wantsOpen) {
        cdLog('[CartDrawer] open() → annule : close() est passe entre-temps');
        return;
      }
      this.classList.add('animate', 'active');
    });

    this.addEventListener('transitionend', () => {
      clearTimeout(this._openedFallback);
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      if (containerToTrapFocusOn) trapFocus(containerToTrapFocusOn, focusElement);
      document.dispatchEvent(new CustomEvent('cart-drawer:opened'));
      cdLog('[CartDrawer] open() → transitionend → cart-drawer:opened dispatched');
    }, { once: true });

    // Si transitionend ne vient jamais (animations reduites, transition absente),
    // on garantit quand meme cart-drawer:opened
    clearTimeout(this._openedFallback);
    this._openedFallback = setTimeout(() => {
      cdLog('[CartDrawer] open() → fallback cart-drawer:opened (pas de transitionend)');
      document.dispatchEvent(new CustomEvent('cart-drawer:opened'));
    }, 700);

    this._scrollY = window.scrollY;
    document.body.style.top = `-${this._scrollY}px`;
    document.body.classList.add('overflow-hidden');
    document.addEventListener('touchmove', this._preventScroll, { passive: false });

    setTimeout(() => {
      cdLog('[CartDrawer] open() → initTimer + updateCartIconBubble');
      this.initTimer();
      this.updateCartIconBubble();
    }, 200);
  }

  /* close() sert a la fois d'action utilisateur (croix, overlay, Echap) et
     d'appel interne. Seule la fermeture UTILISATEUR horodate _closedAt.
     Attention : close est branche comme ecouteur d'evenement, donc le premier
     argument peut etre un Event — d'ou le test sur la propriete plutot que
     sur la presence d'un argument. */
  close(options) {
    const programmatic = !!(options && options.programmatic === true);

    // La fermeture est une intention — elle gagne sur toute ouverture en attente
    this._wantsOpen = false;
    if (!programmatic) this._closedAt = Date.now();

    clearTimeout(this._openTimeout);
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.style.top = '';
    window.scrollTo(0, this._scrollY || 0);
    document.removeEventListener('touchmove', this._preventScroll);
    if (this._timerInterval) {
      clearInterval(this._timerInterval);
      this._timerInterval = null;
    }
    // le watchdog n'est pas arrêté : l'expiration doit rester
    // détectable drawer fermé quand le vidage est actif
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open'));
    });
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.classList.remove('is-empty');
    this.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (sectionElement && parsedState.sections && parsedState.sections[section.id]) {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        const freshOverlay = overlay.cloneNode(true);
        overlay.replaceWith(freshOverlay);
        freshOverlay.addEventListener('click', this.close.bind(this));
      }

      /* CORRECTIF 3 — l'ancienne garde etait « userJustClosed(1500) ».
         renderContents() n'est appele que par product-form.js apres un
         /cart/add.js reussi : l'ajout au panier est toujours une intention
         explicite de voir le panier, il doit donc toujours ouvrir.
         Seul clearCart() a une raison de supprimer la reouverture, et il le
         signale par ce drapeau a usage unique. */
      if (this._suppressReopen) {
        this._suppressReopen = false;
        cdLog('[CartDrawer] renderContents() → panier vide par le timer, on ne rouvre pas');
        document.dispatchEvent(new CustomEvent('cart-drawer:opened'));
      } else if (!themeDrawerIsEngine()) {
        cdLog('[CartDrawer] renderContents() → slide cart applicatif actif, pas d ouverture');
        document.dispatchEvent(new CustomEvent('cart-drawer:opened'));
      } else {
        this.open();
      }

      if (parsedState.item_count > 0) {
        cdLog('[CartDrawer] renderContents() → item_count > 0, initTimer');
        this.initTimer();
      }
      this.updateCartIconBubble();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer-customizer',
        section: 'cart-drawer-customizer',
        selector: '#CartDrawer'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  /* CORRECTIF 1 (partie 1/2) — recharge le contenu du tiroir depuis la
     section Liquid, SANS le marquer vide. C'est le pendant de
     refreshDrawerHTML(), qui lui pose is-empty parce qu'il sert au vidage.
     Utilise par le pont d'ajout externe, en bas de fichier. */
  refreshDrawerContents() {
    return fetch('/cart?section_id=cart-drawer-customizer', { cache: 'no-store' })
      .then((r) => r.text())
      .then((text) => {
        const fresh = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#CartDrawer');
        const current = document.getElementById('CartDrawer');
        if (!fresh || !current) return;

        current.innerHTML = fresh.innerHTML;
        this.classList.remove('is-empty');
        const inner = current.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');

        // innerHTML efface les ecouteurs : reattacher l'overlay,
        // sinon le clic a cote ne fermerait plus le tiroir.
        const overlay = current.querySelector('#CartDrawer-Overlay');
        if (overlay) {
          const f = overlay.cloneNode(true);
          overlay.replaceWith(f);
          f.addEventListener('click', this.close.bind(this));
        }
        cdLog('[CartDrawer] refreshDrawerContents() → contenu recharge');
      })
      .catch(() => {
        cdLog('[CartDrawer] refreshDrawerContents() → echec reseau');
      });
  }

  updateCartIconBubble() {
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (!cartIconBubble) return;
    fetch(`/cart.js?_=${Date.now()}`)
      .then(response => response.json())
      .then(cart => {
        cdLog('[CartDrawer] updateCartIconBubble() → item_count:', cart.item_count);
        let cartCountBubble = cartIconBubble.querySelector('.cart-count-bubble');
        if (cart.item_count > 0) {
          if (!cartCountBubble) {
            cartCountBubble = document.createElement('div');
            cartCountBubble.className = 'cart-count-bubble';
            cartIconBubble.appendChild(cartCountBubble);
          }
          cartCountBubble.style.display = 'flex';
          cartCountBubble.classList.remove('hidden');
          let countSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
          if (!countSpan) {
            countSpan = document.createElement('span');
            countSpan.setAttribute('aria-hidden', 'true');
            cartCountBubble.appendChild(countSpan);
          }
          countSpan.textContent = cart.item_count;
          let hiddenSpan = cartCountBubble.querySelector('span.visually-hidden');
          if (!hiddenSpan) {
            hiddenSpan = document.createElement('span');
            hiddenSpan.className = 'visually-hidden';
            cartCountBubble.appendChild(hiddenSpan);
          }
          hiddenSpan.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'} in cart`;
        } else {
          if (cartCountBubble) cartCountBubble.style.display = 'none';
        }
      })
      .catch(e => console.error('[CartDrawer] updateCartIconBubble() → error:', e));
  }

  /* ----------------------------------------------------------
     Timer — échéance absolue, stockée en cookie ou en mémoire
     selon data-persist-cookie.
     Pourquoi une échéance et non un compteur de secondes :
     l'ancien code réécrivait le cookie à chaque tick avec une
     expiration égale au temps restant. À zéro, le cookie
     disparaissait au même instant — l'expiration devenait
     indétectable au rechargement, et le panier n'était jamais vidé.
     ---------------------------------------------------------- */
  readTimerConfig(el) {
    return {
      minutes: parseInt(el.getAttribute('data-minutes'), 10) || 10,
      persist: el.getAttribute('data-persist-cookie') === 'true',
      clearOnExpire: el.getAttribute('data-clear-cart-on-expire') === 'true'
    };
  }

  getDeadline(persist) {
    if (persist) {
      const raw = this.getCookie('cart_timer_deadline');
      const ts = raw ? parseInt(raw, 10) : NaN;
      return Number.isFinite(ts) ? ts : null;
    }
    return Number.isFinite(this._deadline) ? this._deadline : null;
  }

  setDeadline(ts, cfg) {
    this._deadline = ts;
    if (!cfg.persist) return;
    // Le cookie ne doit survivre à l'échéance que si l'on a besoin
    // de constater l'expiration après coup.
    const cookieEnd = cfg.clearOnExpire ? ts + 24 * 60 * 60 * 1000 : ts;
    document.cookie =
      `cart_timer_deadline=${ts};expires=${new Date(cookieEnd).toUTCString()};path=/`;
  }

  clearDeadline() {
    this._deadline = null;
    this.deleteCookie('cart_timer_deadline');
    this.deleteCookie('cart_timer_remaining'); // purge de l'ancien format
  }

  saveTimerState() {
    // L'échéance est absolue : plus rien à sauvegarder avant
    // un remplacement de HTML.
    if (this._timerInterval) {
      clearInterval(this._timerInterval);
      this._timerInterval = null;
    }
  }

  initTimer(attempt = 0) {
    const el = this.querySelector('.cart-timer');
    const timeSpan = el && el.querySelector('.cart-timer__time');
    if (!el || !timeSpan) {
      if (attempt < 20) {
        setTimeout(() => this.initTimer(attempt + 1), 100);
        return;
      }
      // 2 s sans bannière : panier vide ou timer désactivé.
      // Purge obligatoire, sinon un futur ajout hériterait
      // d'une échéance déjà entamée.
      this.clearDeadline();
      return;
    }
    const cfg = this.readTimerConfig(el);
    this._timerCfg = cfg;
    let deadline = this.getDeadline(cfg.persist);
    if (deadline === null) {
      deadline = Date.now() + cfg.minutes * 60 * 1000;
      this.setDeadline(deadline, cfg);
      cdLog('[CartDrawer] timer → nouvelle échéance', new Date(deadline).toISOString());
    } else if (Date.now() >= deadline) {
      if (cfg.clearOnExpire) {
        cdLog('[CartDrawer] timer → échéance déjà dépassée, vidage');
        this.clearCart();
        return;
      }
      deadline = Date.now() + cfg.minutes * 60 * 1000;
      this.setDeadline(deadline, cfg);
      cdLog('[CartDrawer] timer → échéance dépassée, relance');
    }
    if (this._timerInterval) {
      clearInterval(this._timerInterval);
      this._timerInterval = null;
    }
    const tick = () => {
      const remaining = Math.max(0, Math.round((deadline - Date.now()) / 1000));
      this._currentRemaining = remaining;
      const mm = Math.floor(remaining / 60);
      const ss = remaining % 60;
      timeSpan.textContent = `${mm}:${String(ss).padStart(2, '0')}`;
      if (remaining > 0) return;
      if (cfg.clearOnExpire) {
        clearInterval(this._timerInterval);
        this._timerInterval = null;
        this.clearCart();
      } else {
        deadline = Date.now() + cfg.minutes * 60 * 1000;
        this.setDeadline(deadline, cfg);
      }
    };
    tick();
    this._timerInterval = setInterval(tick, 1000);
    if (cfg.clearOnExpire) this.startExpiryWatchdog();
  }

  /* Surveille l'échéance drawer fermé : close() coupe l'interval
     d'affichage, sinon l'expiration passerait inaperçue.
     Inutile quand le timer se contente de repartir. */
  startExpiryWatchdog() {
    if (this._watchdog) return;
    this._watchdog = setInterval(() => {
      const cfg = this._timerCfg;
      if (!cfg || !cfg.clearOnExpire) return;
      const deadline = this.getDeadline(cfg.persist);
      if (deadline !== null && Date.now() >= deadline) {
        clearInterval(this._watchdog);
        this._watchdog = null;
        cdLog('[CartDrawer] watchdog → expiration');
        this.clearCart();
      }
    }, 5000);
  }

  /* Recharge le HTML du drawer pour afficher l'état vide. */
  refreshDrawerHTML() {
    return fetch('/cart?section_id=cart-drawer-customizer', { cache: 'no-store' })
      .then((r) => r.text())
      .then((text) => {
        const fresh = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#CartDrawer');
        const current = document.getElementById('CartDrawer');
        if (!fresh || !current) return;
        current.innerHTML = fresh.innerHTML;
        this.classList.add('is-empty');
        const inner = current.querySelector('.drawer__inner');
        if (inner) inner.classList.add('is-empty');
        // innerHTML efface les écouteurs : réattacher l'overlay
        const overlay = current.querySelector('#CartDrawer-Overlay');
        if (overlay) {
          const f = overlay.cloneNode(true);
          overlay.replaceWith(f);
          f.addEventListener('click', this.close.bind(this));
        }
      })
      .catch(() => {});
  }

  clearCart() {
    if (this._clearing) return;   // garde contre les appels concurrents
    this._clearing = true;
    if (this._timerInterval) { clearInterval(this._timerInterval); this._timerInterval = null; }
    if (this._watchdog)      { clearInterval(this._watchdog);      this._watchdog = null; }
    this.clearDeadline();
    this._currentRemaining = undefined;
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
      .then((r) => r.json())
      .then(() => this.refreshDrawerHTML())
      .then(() => {
        cdLog('[CartDrawer] clearCart() → panier vidé');
        /* CORRECTIF 3 — remplace « _closedAt = Date.now() ». Horodater la
           fermeture bloquait tout ajout survenant dans la seconde et demie
           qui suivait. Ce drapeau ne neutralise QUE la prochaine
           reouverture, puis se consomme. */
        this._suppressReopen = true;
        this.updateCartIconBubble();
        document.dispatchEvent(new CustomEvent('cart:updated'));
        this.close({ programmatic: true });
      })
      .catch((e) => console.error('[CartDrawer] clearCart() → erreur :', e))
      .finally(() => { this._clearing = false; });
  }

  setCookie(name, value, minutes) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (minutes * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
  }

  restartTimerOnAdd() {
    cdLog('[CartDrawer] restartTimerOnAdd() → nouvelle échéance');
    if (this._timerInterval) {
      clearInterval(this._timerInterval);
      this._timerInterval = null;
    }
    this.clearDeadline();
    this._currentRemaining = undefined;
    setTimeout(() => { this.initTimer(); }, 100);
  }
}
customElements.define('cart-drawer', CartDrawer);

/* Vide le panier d'un visiteur revenu après l'échéance, sans qu'il ait
   besoin de rouvrir le drawer. N'agit que si les deux cases sont cochées :
   sans cookie il n'y a rien à relire, sans vidage il n'y a rien à faire. */
(function checkExpiredCartOnLoad() {
  function run() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const el = drawer.querySelector('.cart-timer');
    if (!el) {
      // Panier vide au chargement : l'échéance héritée doit disparaître.
      // is-empty vient de Liquid ici, donc fiable — contrairement à
      // son état après une mise à jour AJAX.
      if (drawer.classList.contains('is-empty')) drawer.clearDeadline();
      return;
    }
    const cfg = drawer.readTimerConfig(el);
    if (!cfg.clearOnExpire) return;
    if (!cfg.persist) {
      cdLog('[CartDrawer] vidage actif sans cookie : portée limitée à la page courante');
      return;
    }
    const deadline = drawer.getDeadline(true);
    if (deadline === null) return;
    if (Date.now() < deadline) {
      drawer._timerCfg = cfg;
      drawer.startExpiryWatchdog();
      return;
    }
    fetch('/cart.js', { cache: 'no-store' })
      .then((r) => r.json())
      .then((cart) => {
        if (cart.item_count > 0) {
          cdLog('[CartDrawer] chargement → panier expiré, vidage');
          drawer.clearCart();
        } else {
          drawer.clearDeadline();
        }
      })
      .catch(() => {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

// ============================================================
// CART DRAWER ITEMS - definition with robust retry
// ============================================================
(function defineCartDrawerItems() {
  if (typeof CartItems === 'undefined') {
    // Retry with increasing intervals until CartItems is available
    let retryCount = 0;
    const maxRetries = 20;
    const delays = [50, 100, 150, 200, 300, 500, 750, 1000];
    function retry() {
      retryCount++;
      if (typeof CartItems !== 'undefined') {
        cdLog(`[CartDrawerItems] CartItems found after ${retryCount} retries`);
        doDefine();
      } else if (retryCount < maxRetries) {
        const delay = delays[Math.min(retryCount - 1, delays.length - 1)];
        cdLog(`[CartDrawerItems] CartItems not yet defined, retrying in ${delay}ms (attempt ${retryCount})`);
        setTimeout(retry, delay);
      } else {
        console.error('[CartDrawerItems] CartItems still not defined after max retries — giving up');
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', retry);
    } else {
      setTimeout(retry, 50);
    }
    return;
  }
  doDefine();

  function doDefine() {
    if (customElements.get('cart-drawer-items')) {
      cdLog('[CartDrawerItems] already defined, skipping');
      return;
    }
    class CartDrawerItems extends CartItems {
      constructor() {
        super();
        cdLog('[CartDrawerItems] constructor called');
      }
      connectedCallback() {
        cdLog('[CartDrawerItems] connectedCallback → element inserted into DOM');
        if (super.connectedCallback) super.connectedCallback();
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        if (cartDrawerWrapper) {
          // Re-attach overlay listener after DOM replacement
          const overlay = cartDrawerWrapper.querySelector('#CartDrawer-Overlay');
          if (overlay) {
            const fresh = overlay.cloneNode(true);
            overlay.replaceWith(fresh);
            fresh.addEventListener('click', cartDrawerWrapper.close.bind(cartDrawerWrapper));
            cdLog('[CartDrawerItems] connectedCallback → overlay listener re-attached');
          }
          setTimeout(() => {
            cdLog('[CartDrawerItems] connectedCallback → reinitializing timer + bubble');
            cartDrawerWrapper.initTimer();
            cartDrawerWrapper.updateCartIconBubble();
          }, 100);
        }
      }
      getSectionsToRender() {
        return [
          {
            id: 'cart-drawer-customizer',
            section: 'cart-drawer-customizer',
            selector: '#CartDrawer'
          }
        ];
      }
      onCartUpdate() {
        cdLog('[CartDrawerItems] onCartUpdate() → fetching new cart HTML');
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        // Save timer state BEFORE any HTML replacement
        if (cartDrawerWrapper) {
          cartDrawerWrapper.saveTimerState();
        }
        fetch('/cart?section_id=cart-drawer-customizer', { cache: 'no-store' })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            if (cartDrawerWrapper) {
              // Remplacement complet du contenu de #CartDrawer
              const newCartDrawerEl = html.querySelector('#CartDrawer');
              const currentCartDrawerEl = document.getElementById('CartDrawer');
              if (newCartDrawerEl && currentCartDrawerEl) {
                currentCartDrawerEl.innerHTML = newCartDrawerEl.innerHTML;
                cdLog('[CartDrawerItems] onCartUpdate() → full #CartDrawer innerHTML replaced');
                // Remove is-empty states
                cartDrawerWrapper.classList.remove('is-empty');
                const drawerInner = currentCartDrawerEl.querySelector('.drawer__inner');
                if (drawerInner) drawerInner.classList.remove('is-empty');
                // Re-attach overlay
                const overlay = currentCartDrawerEl.querySelector('#CartDrawer-Overlay');
                if (overlay) {
                  const fresh = overlay.cloneNode(true);
                  overlay.replaceWith(fresh);
                  fresh.addEventListener('click', cartDrawerWrapper.close.bind(cartDrawerWrapper));
                }
              } else {
                // Fallback: replace just drawer__inner if #CartDrawer not found
                const sourceQty = html.querySelector('cart-drawer-items');
                if (sourceQty) this.innerHTML = sourceQty.innerHTML;
              }
              setTimeout(() => {
                cdLog('[CartDrawerItems] onCartUpdate() → reinitializing timer + bubble');
                cartDrawerWrapper.initTimer();
                cartDrawerWrapper.updateCartIconBubble();
              }, 100);
            }
          })
          .catch(e => console.error('[CartDrawerItems] onCartUpdate() → error:', e));
      }
    }
    customElements.define('cart-drawer-items', CartDrawerItems);
    cdLog('[CartDrawerItems] defined successfully');
  }
})();

// ─── Generic cart update event ─────────────────────────────
document.addEventListener('cart:updated', function () {
  cdLog('📢 [CartDrawer] cart:updated event received');
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) cartDrawer.updateCartIconBubble();
});

// ============================================================
// CORRECTIF 1 (partie 2/2) — PONT AJOUT EXTERNE
// ============================================================
// Le bouton d'ajout de cette boutique est celui de GemPages
// (gp-product-button-v7-5.js), enveloppe par Kaching Bundles
// (kaching-bundles.js). Il appelle /cart/add.js directement, sans passer par
// product-form.js du theme. renderContents() n'est donc jamais appele, et
// open() non plus : le tiroir n'a aucune raison de s'ouvrir.
//
// Ce pont surveille les appels /cart/add, attend la fin de la rafale,
// rafraichit le contenu du tiroir, puis appelle open(). Il n'invente rien :
// il declenche les methodes que le theme possede deja.
// ============================================================
(function pontAjoutExterne() {
  'use strict';
  if (window.__hlyPontAjoutExterne) return;
  window.__hlyPontAjoutExterne = true;

  /* POURQUOI ON NE PEUT PAS SE CONTENTER D'UN DELAI FIXE
     Un clic produit DEUX ajouts, et l'ecart entre eux est long. Mesure sur
     les horodatages du journal reseau :
         cadeaux (Applicateur, Cadeau Mystere)  t = 0
         produit payant (Fond de Teint)         t = 1654 ms
     Un debounce de 400 ms expirait donc avant l'arrivee du produit principal :
     le tiroir s'ouvrait avec les seuls cadeaux, puis le second ajout relancait
     le cycle et rechargeait tout sous les yeux du client.
     Allonger le delai serait fragile — l'ecart varie avec le reseau. On
     distingue donc les deux appels a la source.

     Kaching ajoute d'abord les lignes cadeaux via
     /cart/add.js?kaching_bundles=true&partial=true
     (methode _addItemsExceptCurrentToCart : « tout sauf le produit courant »),
     puis GemPages ajoute le produit courant via /cart/add.js, sans parametre.
     Ce second appel signale donc la fin de la sequence. */
  const DELAI_FINAL = 300;    /* apres le produit principal : la sequence est finie */
  const FILET       = 2500;   /* si le produit principal n'arrive jamais */

  function rafraichirPuisOuvrir() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      cdLog('[CartDrawer] pont → aucun <cart-drawer> dans la page');
      return;
    }

    /* On rafraichit AVANT d'ouvrir. L'ordre inverse montrerait brievement
       l'ancien panier — souvent vide — avant que les lignes n'apparaissent. */
    drawer.refreshDrawerContents().then(() => {
      /* open() se charge lui-meme de initTimer et updateCartIconBubble
         200 ms plus tard : rien a dupliquer ici. */
      drawer.open();
      cdLog('[CartDrawer] pont → tiroir ouvert');
    });
  }

  let minuteurFinal = null;
  let minuteurFilet = null;

  function programmerOuverture(delai, raison) {
    if (minuteurFinal) clearTimeout(minuteurFinal);
    if (minuteurFilet) { clearTimeout(minuteurFilet); minuteurFilet = null; }
    minuteurFinal = setTimeout(() => {
      cdLog('[CartDrawer] pont → ' + raison);
      rafraichirPuisOuvrir();
    }, delai);
  }

  const fetchOrigine = window.fetch;
  if (!fetchOrigine) return;

  window.fetch = function (entree) {
    let url = '';
    try { url = (typeof entree === 'string') ? entree : ((entree && entree.url) || ''); } catch (e) {}

    const p = fetchOrigine.apply(this, arguments);

    /* /cart/change, /cart/update et /cart.js sont volontairement exclus :
       une suppression ou une lecture ne doit pas ouvrir le tiroir. */
    if (/\/cart\/add/.test(url)) {
      p.then((res) => {
        /* Un ajout refuse (rupture de stock, 422) ne doit rien ouvrir. */
        if (!res || !res.ok) return res;

        if (/kaching_bundles/.test(url)) {
          /* Lignes cadeaux : la sequence n'est PAS terminee, le produit
             principal suit. On n'ouvre pas encore — c'etait la cause du
             rechargement visible. On arme seulement un filet, au cas ou le
             produit principal n'arriverait jamais (bundle sans produit
             courant, ou parametre d'URL modifie par une mise a jour Kaching). */
          cdLog('[CartDrawer] pont → lignes cadeaux, on attend le produit principal');
          if (!minuteurFilet && !minuteurFinal) {
            minuteurFilet = setTimeout(() => {
              minuteurFilet = null;
              cdLog('[CartDrawer] pont → filet : aucun produit principal, ouverture');
              rafraichirPuisOuvrir();
            }, FILET);
          }
        } else {
          /* Produit principal : fin de la sequence, le panier est complet. */
          programmerOuverture(DELAI_FINAL, 'produit principal ajoute, ouverture');
        }
        return res;
      }, () => {});
    }

    /* On rend la promesse d'origine : la chaine appelante reste intacte,
       et les autres enveloppes de fetch deja en place ne sont pas perturbees. */
    return p;
  };

  cdLog('[CartDrawer] pont ajout externe actif');
})();

cdLog('🚀 Cart Drawer JS Loaded - v25.1 - ouverture unique, panier complet');


